export default __webpack_public_path__ + "static/media/nye-party.401aaff5.jpeg";